<template>
  <v-app dark>
    <v-toolbar color="yellow darken-4" fixed app>
      <v-btn icon v-if="$route.meta.backRoute != undefined" @click="goBack()">
        <v-icon color="white">arrow_back</v-icon>
      </v-btn>
      <v-toolbar-side-icon v-else @click="toggleDrawer" class="white--text"></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">{{ toolbarHeader }}</v-toolbar-title>
    </v-toolbar>

    <Drawer
      v-if="!($route.meta.backRoute != undefined)"
      v-model="toolbar.drawer"
      :drawer="toolbar.drawer"
      :menu="menu"
    />

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import * as MENU from "@/menu";
import Drawer from "@/components/Drawer";
import { mapFields } from "vuex-map-fields";
import DotsMenu from "@/components/DotsMenu";
import DEFINES from "@/defines";

export default {
  name: "AppLayout",
  components: {
    Drawer,
    DotsMenu
  },
  computed: {
    ...mapFields("app", ["toolbar"]),
    ...mapGetters({
      selectedCompany: "company/getSelectedCompany",
      toolbarHeader: "app/getToolbarHeader",
      userRoleInCompany: "company/userRoleInCompany"
    }),
    ...mapState({
      session_mode: state => state.app.session_mode
    }),
    menu() {
      return this.session_mode == DEFINES.AVAIL_SESSION_MODE
        ? MENU.guest.dots_menu
        : MENU.distributor.dots_menu({
            allowed: this.isOwnerOrAdmin()
          });
    }
  },

  methods: {
    isOwnerOrAdmin() {
      let role_in_company = this.userRoleInCompany(this.selectedCompany.id);
      return [DEFINES.ROLE_OWNER, DEFINES.ROLE_ADMIN].includes(role_in_company);
    },

    toggleDrawer() {
      this.toolbar.drawer = !this.toolbar.drawer;
    },

    goBack() {
      this.$router.push({
        name: this.$route.meta.backRoute
      });
    }
  }
};
</script>
